import * as React from 'react';
import clsx from 'clsx';
import { Message } from '../Private/Message/Message';
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Popover-root_xCT19",
  "fade": "Popover-fade_6WGqV",
  "appear-top": "Popover-appear-top_1HPCC",
  "appear-left": "Popover-appear-left_1ohMJ",
  "appear-bottom": "Popover-appear-bottom_BzA5E",
  "appear-right": "Popover-appear-right_3cSN7"
};
function Popover({
  id,
  arrow,
  intent = 'info',
  children,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Message, {
    id: id,
    role: "tooltip",
    intent: intent,
    mode: "dark",
    flex: false,
    flexInline: true,
    color: "white",
    className: clsx(styles.root, className),
    ...extraProps,
    children: [children, arrow]
  });
}
export { Popover };